import React, { useEffect } from 'react';

import config from 'config';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useProductContext } from '~/techstyle-shared/react-components';
import { useIntl } from '~/techstyle-shared/react-intl';

import { KlarnaPlacement } from '../Klarna';

const KlarnaContainer = styled.div`
  #klarna-credit-promotion::part(osm-container) {
    border: none;
    padding: 0;
  }

  #klarna-credit-promotion::part(osm-message) {
    text-align: left;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.klarnaCreditPromotion};
    font-family: ${({ theme }) => theme.fontStacks.baseFamily};
    font-weight: 500;
  }

  #klarna-credit-promotion::part(osm-cta) {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.klarnaCreditPromotion};
    font-family: ${({ theme }) => theme.fontStacks.baseFamily};
    font-weight: 500;
  }
`;

function ProductDetailKlarna({ product: productFromProps }) {
  const { locale } = useIntl();
  const productFromContext = useProductContext();
  const product = productFromProps || productFromContext;
  const { defaultUnitPrice, promos = {} } = product;
  const hasPromo =
    Boolean(promos.promoCode) && typeof promos.promoCode === 'string';
  const amount =
    hasPromo && promos.promoPrice > 0 ? promos.promoPrice : defaultUnitPrice;
  const klarnaAmount = Math.floor(amount * 100);

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    window.Klarna?.OnsiteMessaging?.refresh();
  }, [hasPromo, klarnaAmount]);

  return (
    <KlarnaContainer>
      <KlarnaPlacement
        id="klarna-credit-promotion"
        data-autotag="pdp-klarna-text"
        locale={locale}
        amount={klarnaAmount}
        type={config.get('public.klarna.type')}
        scriptSrc={config.get('public.klarna.script')}
        environment={config.get('public.klarna.environment')}
        clientId={config.get('public.klarna.clientId')}
      />
    </KlarnaContainer>
  );
}

ProductDetailKlarna.propTypes = {
  product: PropTypes.object,
};

export default ProductDetailKlarna;
